import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { clearAnalyticsUser } from '../services/analyticsService';
import { getStoredUser, hasAdminAccess } from '../utils/authUser';
import LanguageToggle from './LanguageToggle';
import './GiovanniSite.css';

export default function PublicHeader({ overlay = false }) {
  const { language, t } = useLanguage();
  const user = getStoredUser();
  const isSignedIn = Boolean(user?.token);
  const isAdmin = hasAdminAccess(user);

  const handleLogOut = () => {
    clearAnalyticsUser();
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
    window.location.assign('/');
  };

  return (
    <header className={`gt-header ${overlay ? 'gt-header--overlay' : ''}`}>
      <Link className="gt-brand" to="/" aria-label="HOUSEITGOING home">
        <span className="gt-brand-mark">HIG</span>
        <span><strong>HOUSEITGOING</strong><small>Giovanni Triana · Broker</small></span>
      </Link>
      <nav className="gt-nav" aria-label="Primary navigation">
        <Link to="/search">{t('search')}</Link>
        <Link to="/about-us">{t('about')}</Link>
        <Link to="/areas">{t('areas')}</Link>
        <Link to="/guides">{t('guides')}</Link>
        <Link to="/contact-us">{t('contact')}</Link>
      </nav>
      <div className="gt-header-actions">
        <LanguageToggle />
        {isAdmin ? (
          <Link className="gt-login-link gt-login-link--admin" to="/admin">
            <span aria-hidden="true">⚙</span> Admin
          </Link>
        ) : !isSignedIn ? (
          <Link className="gt-login-link" to="/chat?login=1">
            {language === 'es' ? 'Iniciar sesión' : 'Log in'}
          </Link>
        ) : null}
        {isSignedIn ? (
          <button className="gt-login-link gt-logout-button" type="button" onClick={handleLogOut}>
            {language === 'es' ? 'Salir' : 'Log out'}
          </button>
        ) : null}
      </div>
    </header>
  );
}
